<template>
  <form ref="form">
    <input ref="file" type="file" :accept="accept" :multiple="multiple" @change="onChange"/>
  </form>
</template>

<script>
export default {
  name: "consult-uploader",
  props: ['accept', 'multiple'],
  methods: {
    start() {
      this.$refs.file.click();
    },
    async uploadAndReply(pics) {
      this.$emit('pics', pics);
    },


    async onChange(e) {
      const domFile = e.target;
      const files = domFile.files;
      this.$zhe2dialog.mulPicScan({files})
        .then(pics => {
          this.uploadAndReply(pics)
          this.$refs.form.reset();
        })
        .catch(() => {

        })
    }
  },
}
</script>

<style scoped lang="scss">
@import "~@/common/public.scss";

form {
  position: fixed;
  left: 100vw;
  top: 100vh;
  height: 0px;
  width: 0px;
}
</style>



// WEBPACK FOOTER //
// src/plugins/consult/consult-uploader.vue